import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MyAccountService } from '../../../core/services/my-account/my-account.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent {
  hide = true;
  passwords: string[] = [];
  showPassword: boolean[] = [];
  formData:any = {}
  changingPasswordloading = false
  passwordUpdateRequired = false;
  name:string | null = '';
  email:string | null = '';

  // Password validation properties
  passwordValidations = {
    minLength: false,
    maxLength: false,
    // hasUpperCase: false,
    // hasLowerCase: false,
    // hasSpecialChar: false,
    passwordsMatch: false
  };

  constructor(
    public _snackBar:MatSnackBar,
    private _MyAccountService:MyAccountService,
    private route:Router,
  ){
    if (localStorage.getItem('token')) {
      if (localStorage.getItem('passwordUpdateRequired') === '1'){
        this.passwordUpdateRequired = true
      } 
    } 
    this.name = localStorage.getItem('fullName');
    this.email = localStorage.getItem('email');
  }

  togglePasswordVisibility(index: number) {
    this.showPassword[index] = !this.showPassword[index];
  }

  validatePassword() {
    const newPassword = this.formData.new_password || '';
    const confirmPassword = this.formData.confirm_new_password || '';

    this.passwordValidations = {
      minLength: newPassword.length >= 8,
      maxLength: newPassword.length <= 16,
      // hasUpperCase: /[A-Z]/.test(newPassword),
      // hasLowerCase: /[a-z]/.test(newPassword),
      // hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(newPassword),
      passwordsMatch: newPassword === confirmPassword && newPassword !== ''
    };
  }

  changePassword(form: NgForm){
    console.log(this.formData.old_password)
    if(this.formData.old_password == null || this.formData.old_password == '' || this.formData.old_password == undefined){
      this._snackBar.open('Current Password is required','',{
        duration:2000,verticalPosition: 'top', horizontalPosition: 'end',
        panelClass: ['snackbar_red']
      })
      return false
    }

    if(!this.passwordValidations.passwordsMatch){
      this._snackBar.open('New Password & Confirm New Password Must Be Same','',{
        duration:2000,verticalPosition: 'top', horizontalPosition: 'end',
        panelClass: ['snackbar_red']
      })
      return false
    }

    if(!Object.values(this.passwordValidations).every(validation => validation)) {
      this._snackBar.open('Please ensure all password requirements are met','',{
        duration:2000,verticalPosition: 'top', horizontalPosition: 'end',
        panelClass: ['snackbar_red']
      })
      return false
    }

    this.changingPasswordloading = true;
    this._MyAccountService.resetPassword(this.formData.old_password, this.formData.new_password, this.formData.confirm_new_password).subscribe((data:any)=>{
      this.changingPasswordloading = false;
      if(data.status == "success"){        
        form.resetForm()
        if(localStorage.getItem('passwordUpdateRequired')){
          localStorage.removeItem('passwordUpdateRequired');
          this.route.navigate(['login'])
        }
      }
      this._snackBar.open(data.message,'',{
        duration:3000,
        panelClass: ['snackbar_green'],
        verticalPosition: 'top', horizontalPosition: 'end',
      })
    })
  }
}
